import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export const TransferBarChart = ({
  baseline = 0,
  data = [],
  yAxisLabel,
}: {
  baseline: number;
  data: { name: string; count: number; hour: string }[];
  yAxisLabel: object;
}) => {
  var maxCount = Math.max(...data.map((d) => d.count));
  var maxY = Math.floor(maxCount / baseline);
  maxY = maxY + (maxY % 2 == 0 ? 2 : 1);
  maxY = maxY * baseline;

  const getBarColor = (value: number) => {
    if (value >= 4 * baseline) {
      return "#6c50fa";
    }
    if (value >= 3 * baseline) {
      return "#a894ff";
    }
    if (value >= 2 * baseline) {
      return "#de5c4e";
    }
    if (value >= 1 * baseline) {
      return "#d98843";
    }
    return "#5f9afa";
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        height={300}
        data={data}
        margin={{ top: 28, left: 0, right: 60, bottom: 24 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          label={{
            value: "時",
            position: "insideRight",
            dx: 28,
          }}
          tickSize={8}
          dataKey="hour"
        />
        <YAxis
          label={{
            ...yAxisLabel,
            position: "insideTop",
            dx: 8,
            dy: -28,
          }}
          tickSize={8}
          domain={[0, maxY]}
        />
        <Tooltip
          content={({ active, payload }) => {
            if (active && payload && payload.length) {
              const obj = payload[0] as any;
              return (
                <div className="p:8 bg:white r:8 shadow:0|0|4|black/.6">
                  <p className="fg:gray-40">{obj.payload.name}</p>
                  <p className="mt:4 f:bold fg:blue-50">
                    數量：{obj.payload.count}
                  </p>
                </div>
              );
            }
          }}
        />
        <Bar dataKey="count">
          {data.map((entry, _) => (
            <Cell fill={getBarColor(entry.count)} key={entry.name} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
